import FulfillmentIndexCML from "@/components/billing_cml/fulfillment/FulfillmentIndex.vue";
import FulfillmentAddCML from "@/components/billing_cml/fulfillment/FulfillmentAdd.vue";
import FulfillmentDetailCML from "@/components/billing_cml/fulfillment/FulfillmentDetail.vue";
import FulfillmentEditCML from "@/components/billing_cml/fulfillment/FulfillmentEdit.vue";

let routesFulfillmentAccess= [
    {
        path: '',
        meta: {
          title: "List Fulfillment",
        },
        name: "FulfillmentIndexCML",
        component: FulfillmentIndexCML
    },
    {
        path: 'create',
        meta: {
          title: "Create Fulfillment",
        },
        name: "FulfillmentAddCML",
        component: FulfillmentAddCML
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Fulfillment",
        },
        name: "FulfillmentDetailCML",
        component: FulfillmentDetailCML
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Fulfillment",
        },
        name: "FulfillmentEditCML",
        component: FulfillmentEditCML
    },
    
]

export default routesFulfillmentAccess
  